import { render, staticRenderFns } from "./CellNum.vue?vue&type=template&id=bb1d9fa0&scoped=true"
import script from "./CellNum.vue?vue&type=script&lang=js"
export * from "./CellNum.vue?vue&type=script&lang=js"
import style0 from "./CellNum.vue?vue&type=style&index=0&id=bb1d9fa0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1d9fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb1d9fa0')) {
      api.createRecord('bb1d9fa0', component.options)
    } else {
      api.reload('bb1d9fa0', component.options)
    }
    module.hot.accept("./CellNum.vue?vue&type=template&id=bb1d9fa0&scoped=true", function () {
      api.rerender('bb1d9fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/dashboard/analysis/CellNum.vue"
export default component.exports